module.exports = require('./helpers/bundle-url').getBundleURL('4SxJc') + "ts.worker.893ad931.js";